<template>
    <div>
        <div class="smallContent miscContent">
            <p v-if="!sent">Create new password</p>

            <form @submit.prevent="newpass" v-if="!sent">
                <input
                    type="password"
                    v-on:change="checkPass"
                    v-model="password"
                    placeholder="Password"
                /><br />
                <input
                    type="password"
                    v-model="repeatPassword"
                    v-on:change="checkPass"
                    ref="repeatPass"
                    placeholder="Repeat password"
                /><br />
                <input type="submit" value="Send" />
            </form>

            <p v-if="message" id="message">{{ message }}</p>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
import axios from "axios";
import { store } from "../store";
import Footer from "./Footer.vue";

export default {
    name: "NewPW",
    components: {
        Footer,
    },
    data() {
        return {
            store: store,
            password: "",
            repeatPassword: "",
            passIdentical: true,
            message: "",
            sent: false,
        };
    },
    methods: {
        checkPass() {
            if (this.password == this.repeatPassword) {
                this.$refs.repeatPass.setCustomValidity("");
            } else {
                this.$refs.repeatPass.setCustomValidity(
                    "Passwords don't match"
                );
            }
        },
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        newpass() {
            let myself = this;
            myself.message = "";
            axios.defaults.headers.common["X-CSRFToken"] =
                this.getCookie("csrftoken");
            axios
                .post("/api/new-password", {
                    password: this.password,
                    email: this.$route.params.email,
                })
                .then((response) => {
                    myself.message = response.data.message;
                    myself.sent = true;
                });
        },
    },
    created() {
        axios.get("/api/login-set-cookie");
    },
    activated() {
        this.message = "";
        this.sent = false;
    },
};
</script>

<style scoped>
.miscContent {
    width: min(550px, 100%);
}
p {
    margin-bottom: 0.8rem;
    margin-top: 0;
}
#message {
    margin-top: 0.8rem;
    color: red;
}
</style>
